const VisPageRegister = () => import('@/views/vis-page-register');

export default [
  {
    path: "/register",
    name: "register",
    component: VisPageRegister,
    props: route => ({ state: route.query.state })
  }
]
